/* Top bar mobile ticker: below 750px, reveal one ".topbar__point" at a
   time on a timer; from 750px up show the full row. Idempotent so it
   survives theme-editor section re-renders. */
(function () {
  'use strict';

  function initTopbar(root) {
    if (!root || root.__topbarInit) return;
    root.__topbarInit = true;

    var points = Array.prototype.slice.call(root.querySelectorAll('.topbar__point'));
    if (!points.length) return;

    var mq = window.matchMedia('(max-width: 900px)');
    var index = 0;
    var timer = null;

    function showPoint(i) {
      points.forEach(function (pt, idx) {
        pt.classList.toggle('is-active', idx === i);
      });
    }

    function start() {
      if (timer) return;
      index = 0;
      showPoint(index);
      timer = setInterval(function () {
        index = (index + 1) % points.length;
        showPoint(index);
      }, 3000);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      points.forEach(function (pt) {
        pt.classList.remove('is-active');
      });
    }

    function sync() {
      if (mq.matches) {
        start();
      } else {
        stop();
      }
    }

    sync();
    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }
  }

  function initAll() {
    document.querySelectorAll('.topbar').forEach(initTopbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when a section is added/updated in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var el = event.target.querySelector ? event.target.querySelector('.topbar') : null;
    if (el) initTopbar(el);
  });
})();
